import { confirmToast } from "../../utils/toast";
import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { useNavigate } from "react-router-dom";
import { formatReportDate } from "../../utils/reportDate";

const InvoiceList = () => {

  const navigate = useNavigate();

  const [currencyList, setCurrencyList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAll = () => {
    const updated = invoiceList.map(i => ({
      ...i,
      selected: !selectAll
    }));

    setInvoiceList(updated);
    setSelectAll(!selectAll);
  };
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const formatDate = (date) => formatReportDate(date, "");
  const [filters, setFilters] = useState({
    currency: "",
    supplier: "",
    fromDate: getTodayDate(),   // ✅ default today
    toDate: getTodayDate()      // ✅ default today
  });

  useEffect(() => {
    loadDropdowns();
    searchInvoices();
  }, []);

  const loadDropdowns = async () => {
    try {

      const currencyRes = await axios.get("/invoices/currencies");
      setCurrencyList(currencyRes.data);

      const supplierRes = await axios.get("/invoices/suppliers");
      setSupplierList(supplierRes.data);

    } catch (err) {
      console.error(err);
    }
  };

  const searchInvoices = async () => {
    try {

      const res = await axios.get("/invoices", {
        params: filters
      });

      setInvoiceList(res.data);

    } catch (err) {
      console.error(err);
    }
  };

  const deleteInvoices = async () => {

    const selected = invoiceList.filter(i => i.selected);

    if (selected.length === 0) {
      alert("Please select invoice");
      return;
    }

    const ids = selected.map(i => i.InvoiceId);

    // await axios.delete(`/invoices/${ids[0]}`);
    const deleteInvoices = async () => {
      const selected = invoiceList.filter(i => i.selected);

      if (selected.length === 0) {
        alert("Please select invoice");
        return;
      }

      if (!await confirmToast("Are you sure to delete selected invoices?")) return;

      const ids = selected.map(i => i.InvoiceId);

      await axios.post("/invoices/delete-multiple", { ids }); // ✅ new API

      searchInvoices();
    };
    searchInvoices();
  };

  const toggleSelect = (index) => {
    const data = [...invoiceList];
    data[index].selected = !data[index].selected;
    setInvoiceList(data);
  };

  return (
    <div className="container">

      <h3>Invoice</h3>

      {/* Search Panel */}

      <div className="card p-3 mb-3">

        <div className="row">

          <div className="col-md-3">
            <label>Currency</label>
            <select
              className="form-control"
              value={filters.currency}
              onChange={(e) =>
                setFilters({ ...filters, currency: e.target.value })
              }
            >
              <option value="">Select Currency</option>
              {currencyList.map((c) => (
                <option key={c.Currency_Id} value={c.Currency_Id}>
                  {c.Code}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>Supplier</label>
            <select
              className="form-control"
              value={filters.supplier}
              onChange={(e) =>
                setFilters({ ...filters, supplier: e.target.value })
              }
            >
              <option value="">Select Supplier</option>
              {supplierList.map((s) => (
                <option key={s.ShipperId} value={s.ShipperId}>
                  {s.ShipperName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.fromDate}
              onChange={(e) =>
                setFilters({ ...filters, fromDate: e.target.value })
              }
            />
          </div>

          <div className="col-md-2">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.toDate}
              onChange={(e) =>
                setFilters({ ...filters, toDate: e.target.value })
              }
            />
          </div>

          <div className="col-md-2 d-flex align-items-end">
            <button className="btn btn-primary" onClick={searchInvoices}>
              Search
            </button>
          </div>

        </div>

        <div className="mt-3">

          <button
            className="btn btn-success me-2"
            onClick={() => navigate("/transaction/new-invoice/add")}
          >
            New Invoice
          </button>

          <button
            className="btn btn-danger me-2"
            onClick={deleteInvoices}
          >
            Delete
          </button>

          <button
            className="btn btn-info me-2"
            onClick={() => navigate("/invoice-report")}
          >
            Generate Report
          </button>

          <button
            className="btn btn-warning"
            onClick={() => navigate("/pending-invoice")}
          >
            Pending Invoice
          </button>

        </div>

      </div>

      {/* Invoice Table */}

      <table className="table table-bordered">

        <thead>
          <tr>
            <th>
              <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
            </th>
            <th>Invoice No</th>
            <th>Date</th>
            <th>Supplier</th>
            <th>Amount</th>
            <th>Amount In Rs</th>
            <th>Edit</th>
            <th>Print</th>
          </tr>
        </thead>

        <tbody>

          {invoiceList.map((inv, index) => (
            <tr key={inv.InvoiceId}>

              <td>
                <input
                  type="checkbox"
                  checked={inv.selected || false}
                  onChange={() => toggleSelect(index)}
                />
              </td>

              <td>{inv.InvoiceNo}</td>
              <td>{formatDate(inv.InvoiceDate)}</td>
              <td>{inv.ShipperName}</td>
              <td>{inv.Amount}</td>
              <td>{inv.AmountInRs}</td>

              <td>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() =>
                    navigate(`/transaction/new-invoice/edit/${inv.InvoiceId}`)
                  }
                >
                  Edit
                </button>
              </td>

              <td>
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() =>
                    window.open(`/invoice-print/${inv.InvoiceId}`, "_blank")
                  }
                >
                  Print
                </button>
              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
};

export default InvoiceList;
